import axios from "axios";
import Auth from "../store/auth";


const domain = process.env.VUE_APP_BASE_URL;
// const domain = "http://127.0.0.1:8000/";
// const domain = 'https://lms-2021.maguscube.com/'

export function get(url, params) {
  return axios({
    method: "GET",
    url: domain + url,
    params: params,
    headers: {
      Authorization: `Bearer ${Auth.state.token}`,
    },
  });
}

export function post(url, data) {
  return axios({
    method: "POST",
    url: domain + url,
    data: data,
    headers: {
      Authorization: `Bearer ${Auth.state.token}`,
    },
  });
}

export function put(url, data) {
  return axios({
    method: "PUT",
    url: domain + url,
    data: data,
    headers: {
      Authorization: `Bearer ${Auth.state.token}`,
    },
  });
}

export function del(url) {
  return axios({
    method: "DELETE",
    url: domain + url,
    headers: {
      Authorization: `Bearer ${Auth.state.token}`,
    },
  });
}

export function interceptors(cb) {
  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      cb(error);
      return Promise.reject(error);
    }
  );
}
